import type { ChatMessageSummarySenderBasicInfo } from './chatMessageSummarySenderBasicInfo';
import type { ChatMessageSummarySenderSocial } from './chatMessageSummarySenderSocial';

/**
 * 발신자 정보
 */
export type ChatMessageSummarySender = {
  /** 사용자 기본 정보 */
  basicInfo: ChatMessageSummarySenderBasicInfo;
  /** 소셜 관계 정보 */
  social?: ChatMessageSummarySenderSocial;
};
